// The website's sign-in client (subdomain kit, defaults = production URLs).
// Import { abnjSso } wherever the site needs sign-in.
import { createAbnjSsoSubdomain } from './abnj-sso-subdomain';

export const abnjSso = createAbnjSsoSubdomain();
